if (!customElements.get("blog-filter")) {
  class BlogFilter extends HTMLElement {
    constructor() {
      super();
      this.filterDropdown = document.getElementById("blog-filter-dropdown");
      this.bindEvents();
      this.sortLinksManually();
    }

    bindEvents() {
      this.filterDropdown.addEventListener("change", (evt) => {
        const link = this.querySelector(
          `#blog-filter-links a[data-tag="${evt.detail.selectedValue}"]`
        );
        if (link && link.href && link.href !== "#")
          window.location.href = link.href;
      });
    }

    sortLinksManually() {
      const linksContainer = this.querySelector("#blog-filter-links");
      const links = Array.from(linksContainer.querySelectorAll("a"));

      // Define the desired order of links
      const desiredOrder = ["-", "Guide", "Advices", "Blog"]; // Replace with your desired order

      // Sort the links based on the desired order
      const sortedLinks = desiredOrder.map((tag) =>
        links.find((link) => link.dataset.tag === tag)
      );

      // Clear the container
      linksContainer.innerHTML = "";

      // Append the sorted links back to the container
      sortedLinks.forEach((link) => linksContainer.appendChild(link));
    }
  }

  customElements.define("blog-filter", BlogFilter);
}
